import { render, staticRenderFns } from "./Anli.vue?vue&type=template&id=77b4a64a&scoped=true&"
import script from "./Anli.vue?vue&type=script&lang=js&"
export * from "./Anli.vue?vue&type=script&lang=js&"
import style0 from "./Anli.vue?vue&type=style&index=0&id=77b4a64a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4a64a",
  null
  
)

export default component.exports